import React from "react";
import { Button, Col } from "react-bootstrap";
import ReactLoading from "react-loading";

import "./Buttons.css";

function BtnDelete({ size, onClick, isClicked, label, outline, disabled, id, style }) {
  return (
    <Col className="p-1">
      {isClicked ? (
        <Button id={id} className="action-btn cancel loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#dc3545" />
        </Button>
      ) : (
        <Button
          id={id}
          className={`action-btn cancel ${outline && "cancel-clear"}`}
          size={size}
          onClick={onClick}
          disabled={disabled}
          style={style}
        >
          {label}
        </Button>
      )}
    </Col>
  );
}

export default BtnDelete;
